import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { admAPI } from "../../lib/admApi";
import { PageHeader, Loading, StatusPill, DataTable, Section } from "../../components/Common";
import { ArrowLeft, Check } from "lucide-react";
import { toast } from "sonner";

export default function EnquiriesInbox() {
  const { school } = useParams();
  const nav = useNavigate();
  const [items, setItems] = useState(null);

  const load = () => admAPI.enquiries().then(({ data }) => setItems(data)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);

  const setStatus = async (id, status) => {
    try { await admAPI.updateEnquiry(id, { status }); toast.success("Updated"); load(); }
    catch { toast.error("Failed"); }
  };

  if (items === null) return <Loading />;

  return (
    <div data-testid="enquiries-inbox">
      <PageHeader
        kicker="Admissions360™ · Enquiry Desk"
        title="Enquiry inbox"
        subtitle={`${items.length} enquiries · new, contacted, converted, closed`}
        actions={
          <button onClick={() => nav(`/education360/${school}/admissions`)} className="hl-button-secondary text-xs">
            <ArrowLeft className="w-3 h-3 inline mr-1" />Command Centre
          </button>
        }
      />
      <Section>
        <DataTable
          testId="enquiries-table"
          columns={[
            { key: "parent_name", label: "Parent" },
            { key: "student_name", label: "Student" },
            { key: "year_group", label: "Year" },
            { key: "country", label: "Country" },
            { key: "interests", label: "Interests", render: r => [r.boarding_interest && "Boarding", r.transport_interest && "Transport", r.tour_requested && "Tour", r.virtual_meeting && "Virtual meet"].filter(Boolean).join(" · ") },
            { key: "parent_email", label: "Contact" },
            { key: "status", label: "Status", render: r => <StatusPill status={r.status} /> },
            {
              key: "actions", label: "Actions", render: r => (
                <div className="flex gap-1">
                  {["contacted", "converted", "closed"].map(s => (
                    <button
                      key={s}
                      className="text-[10px] px-1.5 py-0.5 border border-slate-200 rounded"
                      onClick={() => setStatus(r.id, s)}
                      data-testid={`enq-${r.id}-${s}`}
                    >
                      {s}
                    </button>
                  ))}
                </div>
              )
            },
          ]}
          rows={items}
        />
      </Section>
    </div>
  );
}
